/* eslint-disable curly */
/* eslint-disable nonblock-statement-body-position */
/* eslint-disable no-use-before-define */
/* eslint-disable no-restricted-globals */
/* eslint-disable radix */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-confusing-arrow */
/* eslint-disable indent */
/* eslint-disable array-callback-return */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSet,
  Button,
  Checkbox,
  Icon,
  IconButton,
  TextField,
  Tooltip,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { useField } from 'react-final-form';
import { Virtuoso } from 'react-virtuoso';
import { v4 as uuidv4 } from 'uuid';
import {
  FaEdit,
  FaTrash,
  FaCopy,
  FaFolderPlus,
  FaChevronDown,
  FaChevronUp,
  FaSync,
  FaBarcode,
} from 'react-icons/fa';
import { BiSolidSelectMultiple } from 'react-icons/bi';
import { GoNumber } from 'react-icons/go';
import { chain } from 'lodash';
import EmptyData from '../../../../../../shared/EmptyData';
import RenderItem from '../RenderItem';
import useBarcodeGenerator from '../../../../../../hooks/Barcode/useBarcodeGenerator';
import useLocationName from '../../../../../../hooks/useLocationName';
import { setDefaultValues } from '../../../../../../utils/utils';
import ConfirmDeleteItemsModal from './modals/ConfirmDeleteItemsModal';
import SelectBatchModal from './modals/SelectBatchModal';
// import GoToModal from '../modals/GoToModal';

// Import volume management modals and helper functions
import {
  AddVolumeModal,
  DeleteVolumeModal,
  ResetVolumeModal,
  DuplicateVolumeModal,
  BatchDeleteVolumesModal,
  BatchEditVolumesModal,
  useVolumeManagement,
  getVolumeNumber,
  getNextCopyNumberForVolume,
  recalculateCopyNumbers,
  getExistingVolumes,
  getVolumeItemsCount,
} from '../VolumeManagement';
import CreateItemsBatchModal from './modals/CreateItemsBatchModal';
import CreateSingleItemModal from './modals/CreateSingleItemModal';
import useUndoStack from './hooks/useUndoStack';
import { useBarcodeSession } from '../../../../../../contexts/BarcodeSessionContext';
import EditItemsBatchModal from './modals/EditItemsBatch';
import GoToModal from './modals/GoToModal';

function ItemsList({
  fields,
  template,
  holdingsRecordId,
  holdingLocationId,
  controlledVocab,
  isFullScreen,
  shouldGroupByVolumes,
  onEditItem,
  onUndoStackUpdate,
  isBatchModeActive = false,
  instanceStatisticalCodeIds = [],
}) {
  // Barcode session management for duplicate checking
  const { addBarcodes, removeBarcodes } = useBarcodeSession();

  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [openEditBatchModal, setOpenEditBatchModal] = useState(false);
  const [openDeleteItemsModal, setOpenDeleteItemsModal] = useState(false);

  // State for volume-specific selections
  const [volumeSelections, setVolumeSelections] = useState({});
  const [volumeSelectAll, setVolumeSelectAll] = useState({});

  // State for multi-volume selection
  const [selectedVolumes, setSelectedVolumes] = useState([]);

  // New states for volume management
  const [showAddVolumeModal, setShowAddVolumeModal] = useState(false);
  const [showDeleteVolumeModal, setShowDeleteVolumeModal] = useState(false);
  const [showDuplicateVolumeModal, setShowDuplicateVolumeModal] =
    useState(false);
  const [showResetVolumeModal, setShowResetVolumeModal] = useState(false);
  const [selectedVolumeForAction, setSelectedVolumeForAction] = useState(null);
  const [volumeAccordionStatus, setVolumeAccordionStatus] = useState({});

  // State for batch item creation (non-volume mode)
  const [showCreateBatchItemsModal, setShowCreateBatchItemsModal] =
    useState(false);

  // State for single item creation modal
  const [showCreateSingleItemModal, setShowCreateSingleItemModal] =
    useState(false);

  // State for selected volume when creating single item in volume mode
  const [selectedVolumeForModal, setSelectedVolumeForModal] = useState(null);

  // State for batch volume operations
  const [showBatchDeleteVolumesModal, setShowBatchDeleteVolumesModal] =
    useState(false);
  const [isBatchDeleting, setIsBatchDeleting] = useState(false);
  const [showBatchEditVolumesModal, setShowBatchEditVolumesModal] =
    useState(false);
  const [isBatchEditing, setIsBatchEditing] = useState(false);

  const [isSelectBatch, setIsSelectBatch] = useState(false);

  // Go to navigation
  const [highlightedIndex, setHighlightedIndex] = useState(null);
  const itemsListRef = useRef(null);

  // Go to modal
  const [goToModalOpen, setGoToModalOpen] = useState(false);
  const [goToMode, setGoToMode] = useState(null);

  // FIXED: Move classification fields definition before using them in hooks
  const classificationField = useField('instanceData.classifications');
  const classificationNumber =
    classificationField?.input?.value?.[0]?.classificationNumber || '';
  const authorNumber = classificationField?.input?.value?.[0]?.authorNumber
    ? ` ${classificationField.input.value[0].authorNumber}`
    : '';

  const instanceStatisticalCodeIdsField = useField('instanceData.statisticalCodeIds');
  const instanceStatisticalCodeIdsFromForm = instanceStatisticalCodeIdsField?.input?.value || [];

  const { generateBarcodeValue } = useBarcodeGenerator();
  const { locationCode } = useLocationName(holdingLocationId, controlledVocab);

  const templatesConfigs = controlledVocab.templatesConfigs;

  const {
    configValue: { enableGenerator, autoGenerate },
  } = templatesConfigs.find(
    (config) => config.configName === 'generatorSettings',
  );

  const setBarcodeValue = (permanentLocationId, newIndex) => {
    if (enableGenerator && autoGenerate) {
      return generateBarcodeValue(permanentLocationId, locationCode, newIndex);
    } else {
      return '';
    }
  };

  // Helper function to reset volume states - OPTIMIZED (declaration moved up)
  const resetVolumeStates = () => {
    if (shouldGroupByVolumes) {
      setVolumeSelections((prev) => {
        const reset = {};
        Object.keys(prev).forEach((vol) => {
          reset[vol] = [];
        });
        return reset;
      });
      setVolumeSelectAll((prev) => {
        const reset = {};
        Object.keys(prev).forEach((vol) => {
          reset[vol] = false;
        });
        return reset;
      });
      // Reset volume multi-selection states
      setSelectedVolumes([]);
    }
  };

  // Use Undo functionality hook
  const {
    undoStack,
    createUndoAction,
    executeUndo,
    setShowUndoHistory,
    renderUndoNotification,
    renderUndoHistory,
  } = useUndoStack({
    fields,
    setSelectedItems,
    setSelectAll,
    resetVolumeStates,
  });

  // Create stable refs for functions
  const onUndoStackUpdateRef = useRef(onUndoStackUpdate);
  const renderUndoHistoryRef = useRef(renderUndoHistory);
  const setShowUndoHistoryRef = useRef(setShowUndoHistory);
  const executeUndoRef = useRef(executeUndo);

  // Update refs when functions change
  useEffect(() => {
    onUndoStackUpdateRef.current = onUndoStackUpdate;
    renderUndoHistoryRef.current = renderUndoHistory;
    setShowUndoHistoryRef.current = setShowUndoHistory;
    executeUndoRef.current = executeUndo;
  });

  // Send undo stack updates to parent component (only in normal mode) - STABLE
  useEffect(() => {
    if (onUndoStackUpdateRef.current && !shouldGroupByVolumes) {
      onUndoStackUpdateRef.current(
        undoStack,
        renderUndoHistoryRef.current,
        setShowUndoHistoryRef.current,
        executeUndoRef.current,
      );
    }
  }, [undoStack, shouldGroupByVolumes]);

  // Use Volume Management hook - NOW classificationNumber and authorNumber are defined
  const {
    handleAddVolume,
    handleDeleteVolume,
    handleDuplicateVolume,
    handleAddItemToVolume,
    resetVolumeItemNumbers,
    toggleAllVolumeAccordions,
  } = useVolumeManagement({
    fields,
    template,
    holdingsRecordId,
    holdingLocationId,
    classificationNumber,
    authorNumber,
    setBarcodeValue,
    setSelectedItems,
    setSelectAll,
    resetVolumeStates,
    createUndoAction,
    setShowCreateSingleItemModal,
    setSelectedVolumeForModal,
    volumeAccordionStatus,
    setVolumeAccordionStatus,
  });

  // Use helper function from volumeUtils
  const existingVolumes = React.useMemo(() => {
    return getExistingVolumes(fields, shouldGroupByVolumes);
  }, [shouldGroupByVolumes, fields?.value]);

  // Memoize existing barcodes to avoid infinite re-renders
  const existingBarcodes = React.useMemo(() => {
    return fields?.value?.map((item) => item.barcode).filter(Boolean) || [];
  }, [fields?.value]);

  // Memoize volume item counts for batch operations
  const volumeItemCounts = React.useMemo(() => {
    const counts = {};
    existingVolumes.forEach((volume) => {
      counts[volume] = getVolumeItemsCount(fields, volume);
    });
    return counts;
  }, [fields?.value, existingVolumes]);

  // Initialize volume selections when fields change - OPTIMIZED
  useEffect(() => {
    if (shouldGroupByVolumes) {
      const fieldsArray = fields?.value || [];
      if (fieldsArray.length) {
        const groupedData = chain(fieldsArray)
          .sortBy((item) => getVolumeNumber(item.volume))
          .groupBy((item) => item.volume || 'No_Volume')
          .value();

        setVolumeSelections((prev) => {
          const newVolumeSelections = { ...prev };
          Object.keys(groupedData).forEach((volume) => {
            if (!newVolumeSelections[volume]) {
              newVolumeSelections[volume] = [];
            }
          });
          return newVolumeSelections;
        });

        setVolumeSelectAll((prev) => {
          const newVolumeSelectAll = { ...prev };
          Object.keys(groupedData).forEach((volume) => {
            if (!(volume in newVolumeSelectAll)) {
              newVolumeSelectAll[volume] = false;
            }
          });
          return newVolumeSelectAll;
        });

        // Ensure accordion status for new volumes
        setVolumeAccordionStatus((prevStatus) => {
          const newStatus = { ...prevStatus };
          Object.keys(groupedData).forEach((volume) => {
            const key = `accordion-volume-${volume}`;
            if (!(key in newStatus)) {
              newStatus[key] = false;
            }
          });
          return newStatus;
        });
      } else {
        setVolumeSelections({});
        setVolumeSelectAll({});
      }
    }
  }, [shouldGroupByVolumes, fields?.value?.length]);

  useEffect(() => {
    // Build volume accordion status object only
    const fieldsArray = fields?.value || [];
    if (fieldsArray.length && shouldGroupByVolumes) {
      setVolumeAccordionStatus((prevStatus) => {
        const statuses = { ...prevStatus };

        // Add volume accordion statuses
        const groupedData = chain(fieldsArray)
          .sortBy((item) => getVolumeNumber(item.volume))
          .groupBy((item) => item.volume || 'No_Volume')
          .value();

        Object.keys(groupedData).forEach((volume) => {
          const key = `accordion-volume-${volume}`;
          if (!(key in statuses)) {
            statuses[key] = false;
          }
        });

        // Clean up removed volumes - only if needed
        const volumeKeys = Object.keys(groupedData).map(
          (vol) => `accordion-volume-${vol}`,
        );
        const statusKeys = Object.keys(statuses);
        const hasInvalidKeys = statusKeys.some(
          (key) => !volumeKeys.includes(key),
        );

        if (hasInvalidKeys) {
          statusKeys.forEach((key) => {
            if (!volumeKeys.includes(key)) {
              delete statuses[key];
            }
          });
        }

        return statuses;
      });
    } else if (!shouldGroupByVolumes) {
      setVolumeAccordionStatus({});
    }
  }, [shouldGroupByVolumes, fields?.value?.length]);

  useEffect(() => {
    // Update callNumber after classification field updated
    const classification = classificationField?.input?.value?.[0];
    const fieldsArray = fields?.value || [];
    if (!classification || !fieldsArray.length) return;

    const callNumber = `${classification.classificationNumber || ''}${
      classification.authorNumber ? ` ${classification.authorNumber}` : ''
    }`;

    fieldsArray.forEach((field, indx) => {
      if (field.itemLevelCallNumber !== callNumber) {
        fields.update(indx, {
          ...field,
          itemLevelCallNumber: callNumber,
        });
      }
    });
  }, [classificationField?.input?.value, fields]);

  // Update itemStatisticalCodeIds when instance statisticalCodeIds changes
  useEffect(() => {
    const fieldsArray = fields?.value || [];
    if (!fieldsArray.length) return;

    const newCodes = instanceStatisticalCodeIdsFromForm;
    fieldsArray.forEach((field, indx) => {
      if (JSON.stringify(field.itemStatisticalCodeIds || []) !== JSON.stringify(newCodes)) {
        fields.update(indx, {
          ...field,
          itemStatisticalCodeIds: newCodes,
        });
      }
    });
  }, [JSON.stringify(instanceStatisticalCodeIdsFromForm)]);

  // Handle single item creation for both normal and volume modes
  const handleCreateSingleItem = (itemData) => {
    const itemId = uuidv4();

    // Track barcode for session management
    const newBarcode = itemData.barcode;

    // If we have a selected volume, use volume-specific logic
    if (selectedVolumeForModal) {
      const nextCopyNumber = getNextCopyNumberForVolume(
        fields,
        selectedVolumeForModal,
      );

      fields.push({
        ...itemData,
        id: itemId,
        holdingsRecordId,
        copyNumber: itemData.copyNumber || nextCopyNumber,
        itemLevelCallNumber:
          itemData.itemLevelCallNumber ||
          `${classificationNumber}${authorNumber}`,
        volume:
          selectedVolumeForModal !== 'No_Volume' ? selectedVolumeForModal : '',
      });

      // Recalculate copy numbers for the volume to ensure sequential numbering
      setTimeout(() => {
        recalculateCopyNumbers(fields, selectedVolumeForModal);
      }, 100);

      // Reset selected volume
      setSelectedVolumeForModal(null);
    } else {
      // Normal mode - non-volume
      const normalModeItem = {
        ...itemData,
        id: itemId,
        holdingsRecordId,
        copyNumber:
          itemData.copyNumber || (fields.value ? fields.value.length + 1 : 1),
        itemLevelCallNumber:
          itemData.itemLevelCallNumber ||
          `${classificationNumber}${authorNumber}`,
      };

      fields.push(normalModeItem);
    }

    // Add barcode to session tracking
    if (newBarcode && newBarcode.trim() !== '') {
      addBarcodes([newBarcode.trim()]);
    }

    // Item created successfully
  };

  // Handle batch item creation for non-volume mode
  const handleCreateBatchItems = (itemCount, barcodeSettings = null) => {
    if (!itemCount || itemCount <= 0) return;

    let currentBarcodeIndex = fields.value ? fields.value.length : 0;
    const newBarcodes = []; // Track barcodes for session management

    for (let i = 0; i < itemCount; i++) {
      const itemId = uuidv4();
      const copyNumber = (fields.value ? fields.value.length : 0) + i + 1;

      // Use sequential barcode if available, otherwise auto-generate
      let barcode = '';
      if (
        barcodeSettings &&
        barcodeSettings.barcodes &&
        barcodeSettings.barcodes.length > i
      ) {
        barcode = barcodeSettings.barcodes[i] || '';
      } else {
        barcode = setBarcodeValue(holdingLocationId, currentBarcodeIndex + 1);
      }

      const newItem = {
        ...setDefaultValues(template?.templateFields?.items),
        id: itemId,
        holdingsRecordId,
        permanentLocation: { id: holdingLocationId },
        barcode,
        copyNumber,
        itemLevelCallNumber: `${classificationNumber}${authorNumber}`,
        ...(instanceStatisticalCodeIds.length && { itemStatisticalCodeIds: instanceStatisticalCodeIds }),
      };

      fields.push(newItem);
      currentBarcodeIndex++;

      // Track barcode for session management
      if (barcode && barcode.trim() !== '') {
        newBarcodes.push(barcode.trim());
      }
    }

    // Add all new barcodes to session tracking
    if (newBarcodes.length > 0) {
      addBarcodes(newBarcodes);
    }
  };

  const updateSelection = (e) => {
    const value = e.target.value;
    if (e.target.checked) {
      setSelectedItems((curState) => [...curState, Number(value)]);
    } else {
      setSelectedItems((curState) =>
        curState.filter((s) => Number(s) !== Number(value)),
      );
      setSelectAll(false);
    }
  };

  // Volume-specific selection handlers
  const updateVolumeSelection = (e, volume) => {
    const value = e.target.value;
    if (e.target.checked) {
      setVolumeSelections((prev) => ({
        ...prev,
        [volume]: [...prev[volume], Number(value)],
      }));
    } else {
      setVolumeSelections((prev) => ({
        ...prev,
        [volume]: prev[volume].filter((s) => Number(s) !== Number(value)),
      }));
      setVolumeSelectAll((prev) => ({
        ...prev,
        [volume]: false,
      }));
    }
  };

  // Handle edit item in slide panel
  const handleEditItem = useCallback(
    (itemIndex) => {
      if (onEditItem) {
        onEditItem(
          itemIndex,
          fields,
          holdingsRecordId,
          template,
          controlledVocab,
        );
      }
    },
    [onEditItem, fields, holdingsRecordId, template, controlledVocab],
  );

  const toggleVolumeSelectAll = (e, volume, volumeItems) => {
    const fieldsArray = fields?.value || [];
    if (e.target.checked) {
      const volumeIndices = volumeItems.map((item) =>
        fieldsArray.findIndex((field) => field.id === item.id),
      );
      setVolumeSelections((prev) => ({
        ...prev,
        [volume]: volumeIndices,
      }));
      setVolumeSelectAll((prev) => ({
        ...prev,
        [volume]: true,
      }));
    } else {
      setVolumeSelections((prev) => ({
        ...prev,
        [volume]: [],
      }));
      setVolumeSelectAll((prev) => ({
        ...prev,
        [volume]: false,
      }));
    }
  };

  // Volume multi-selection handlers
  const toggleVolumeSelection = (volume) => {
    setSelectedVolumes((prev) => {
      if (prev.includes(volume)) {
        return prev.filter((v) => v !== volume);
      } else {
        return [...prev, volume];
      }
    });
  };

  // Batch delete volumes handler
  const handleBatchDeleteVolumes = async () => {
    if (selectedVolumes.length === 0) return;

    setIsBatchDeleting(true);

    try {
      // Process each selected volume
      for (const volume of selectedVolumes) {
        await handleDeleteVolume(volume);
      }

      // Clear selection
      setSelectedVolumes([]);
      setShowBatchDeleteVolumesModal(false);
    } catch (error) {
      console.error('Error in batch delete:', error);
    } finally {
      setIsBatchDeleting(false);
    }
  };

  // Batch edit volumes handler
  const handleBatchEditVolumes = async (editData) => {
    if (selectedVolumes.length === 0) return;

    setIsBatchEditing(true);

    try {
      const { operation, prefix, resetCopyNumbers } = editData;

      // Process each selected volume
      for (const volume of selectedVolumes) {
        if (operation === 'changePrefix') {
          // Change volume prefix
          const volumeNumber = getVolumeNumber(volume);
          const newVolumeString = prefix + volumeNumber;

          // Use existing reset function to change volume
          resetVolumeItemNumbers(volume, newVolumeString);
        } else if (operation === 'resetNumbers' && resetCopyNumbers) {
          // Just reset copy numbers without changing volume name
          resetVolumeItemNumbers(volume, volume);
        }
      }

      // Clear selection
      setSelectedVolumes([]);
      setShowBatchEditVolumesModal(false);
    } catch (error) {
      console.error('Error in batch edit:', error);
    } finally {
      setIsBatchEditing(false);
    }
  };

  const toggleSelectAll = (e) => {
    const fieldsArray = fields?.value || [];
    if (e.target.checked) {
      setSelectedItems([
        ...new Array(fieldsArray.length).fill(0).map((_, i) => Number(i)),
      ]);
      setSelectAll(true);
    } else {
      setSelectedItems([]);
      setSelectAll(false);
    }
  };

  const onToggleAccordion = useCallback(({ id }) => {
    setVolumeAccordionStatus((current) => ({
      ...current,
      [id]: !current[id],
    }));
  }, []);

  // Regular accordion toggle with new icon style
  const onToggleAllAccordions = useCallback(() => {
    const fieldsArray = fields?.value || [];
    if (!fieldsArray.length) return;

    if (shouldGroupByVolumes) {
      // For volume mode, toggle all volume accordions
      toggleAllVolumeAccordions();
    }
    // Note: Regular mode toggle removed since items are now flat (no accordions)
  }, [shouldGroupByVolumes, fields?.value, toggleAllVolumeAccordions]);

  const goToIndexFunc = (index) => {
    if (itemsListRef.current) {
      itemsListRef.current.scrollToIndex({
        index: index - 1,
        align: 'start',
        behavior: 'smooth',
      });

      // Add visual highlighting for target item
      setHighlightedIndex(index);
    }
  };

  // Open go to modal
  const openGoToModal = (mode) => {
    setGoToMode(mode);
    setGoToModalOpen(true);
  };

  // Handle go to from modal
  const handleGoToFromModal = (value, mode) => {
    if (mode === 'index') {
      goToIndexFunc(Number(value));
    } else if (mode === 'barcode') {
      if (!value || !fields?.value) {
        return;
      }

      // Search for item with matching barcode
      const itemIndex = fields.value.findIndex((item) => {
        const itemBarcode = item?.barcode?.trim().toLowerCase();
        const searchBarcode = value.trim().toLowerCase();
        return itemBarcode === searchBarcode;
      });

      if (itemIndex !== -1) {
        goToIndexFunc(itemIndex + 1);
      } else {
        alert(`المادة بالباركود "${value}" غير موجودة`);
      }
    }
  };

  const renderSelectBatch = () => {
    return (
      <Tooltip
        id="holding-items-accordion-header-select-batch-tooltip"
        text={
          <FormattedMessage
            id="ui-plugin-inventory-templates.holdingItemsAccordionHeader.selectBatchBtn.tooltip.msg"
            defaultMessage="Select batch"
          />
        }
      >
        {({ ref, ariaIds }) => (
          <Button
            buttonStyle="slim"
            onClick={() => setIsSelectBatch(true)}
            aria-labelledby={ariaIds.text}
            ref={ref}
            align="center"
            paddingSide0
            marginBottom0
            onMouseDown={(e) => e.preventDefault()}
            disabled={selectAll}
          >
            <BiSolidSelectMultiple size={17} />
          </Button>
        )}
      </Tooltip>
    );
  };

  // Render go to index button
  const renderGoToIndexButton = () => {
    return (
      <Tooltip
        id="go-to-index-tooltip"
        text={
          <FormattedMessage
            id="ui-plugin-inventory-templates.goToIndex.tooltip"
            defaultMessage="Navigate by index"
          />
        }
      >
        {({ ref, ariaIds }) => (
          <Button
            type="button"
            buttonStyle="slim"
            marginBottom0
            onClick={() => openGoToModal('index')}
            aria-labelledby={ariaIds.text}
            ref={ref}
          >
            <GoNumber size={17} />
          </Button>
        )}
      </Tooltip>
    );
  };

  // Render go to barcode button
  const renderGoToBarcodeButton = () => {
    return (
      <Tooltip
        id="go-to-barcode-tooltip"
        text={
          <FormattedMessage
            id="ui-plugin-inventory-templates.goToBarcode.tooltip"
            defaultMessage="Navigate by barcode"
          />
        }
      >
        {({ ref, ariaIds }) => (
          <Button
            type="button"
            buttonStyle="slim"
            marginBottom0
            onClick={() => openGoToModal('barcode')}
            aria-labelledby={ariaIds.text}
            ref={ref}
          >
            <FaBarcode size={17} />
          </Button>
        )}
      </Tooltip>
    );
  };

  // Holdings-level volume management toolbar - with gray background like volume toolbar
  const renderHoldingsVolumeManagementToolbar = () => {
    if (!shouldGroupByVolumes) return null;

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: fields?.value?.length ? 'space-between' : 'flex-end',
          padding: '12px 16px',
          alignItems: 'center',
          backgroundColor: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '6px',
          marginBottom: '16px',
        }}
      >
        {/* Start Actions - Volume Selection Controls */}
        {fields?.value?.length > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            {/* Volume Select All Checkbox */}
            <div>
              <Tooltip
                id="volume-select-all-tooltip"
                text={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.holdingsVolumeManagement.selectAllVolumes.tooltip"
                    defaultMessage="Select all volumes"
                  />
                }
              >
                {({ ref, ariaIds }) => (
                  <div aria-labelledby={ariaIds.text} ref={ref}>
                    <Checkbox
                      value="selectAllVolumes"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedVolumes(existingVolumes);
                        } else {
                          setSelectedVolumes([]);
                        }
                      }}
                      checked={
                        selectedVolumes.length === existingVolumes.length &&
                        existingVolumes.length > 0
                      }
                      onMouseDown={(e) => e.preventDefault()}
                      disabled={!existingVolumes.length}
                    />
                  </div>
                )}
              </Tooltip>
            </div>

            {/* Volume Count Info */}
            <div>
              <span
                style={{
                  fontSize: '13px',
                  color: '#495057',
                  fontWeight: '500',
                }}
              >
                <FormattedMessage
                  id="ui-plugin-inventory-templates.holdingsVolumeManagement.volumeCount"
                  values={{
                    count: existingVolumes.length,
                  }}
                  defaultMessage="{count} volumes"
                />
                {selectedVolumes.length > 0 && (
                  <span
                    style={{
                      marginLeft: '8px',
                      color: '#28a745',
                      backgroundColor: '#d4edda',
                      padding: '2px 6px',
                      borderRadius: '10px',
                      fontSize: '11px',
                      fontWeight: '600',
                    }}
                  >
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.holdingsVolumeManagement.selectedCount"
                      values={{ count: selectedVolumes.length }}
                      defaultMessage="{count} selected"
                    />
                  </span>
                )}
              </span>
            </div>
          </div>
        )}

        {/* End Actions - Volume Management Controls */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          {/* Selected Volumes Actions */}
          {selectedVolumes.length > 0 && (
            <>
              <div>
                <Tooltip
                  id="volume-delete-selected-tooltip"
                  text={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.holdingsVolumeManagement.deleteSelected.tooltip"
                      defaultMessage="Delete selected volumes"
                    />
                  }
                >
                  {({ ref, ariaIds }) => (
                    <Button
                      buttonStyle="slim"
                      disabled={!selectedVolumes.length}
                      onClick={() => setShowBatchDeleteVolumesModal(true)}
                      onMouseDown={(e) => e.preventDefault()}
                      marginBottom0
                      aria-labelledby={ariaIds.text}
                      ref={ref}
                    >
                      <FaTrash size={14} />
                    </Button>
                  )}
                </Tooltip>
              </div>
              <div>
                <Tooltip
                  id="volume-edit-selected-tooltip"
                  text={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.holdingsVolumeManagement.editSelected.tooltip"
                      defaultMessage="Edit selected volumes"
                    />
                  }
                >
                  {({ ref, ariaIds }) => (
                    <Button
                      buttonStyle="slim"
                      disabled={!selectedVolumes.length}
                      onClick={() => setShowBatchEditVolumesModal(true)}
                      onMouseDown={(e) => e.preventDefault()}
                      marginBottom0
                      aria-labelledby={ariaIds.text}
                      ref={ref}
                    >
                      <FaEdit size={14} />
                    </Button>
                  )}
                </Tooltip>
              </div>
            </>
          )}

          {/* Expand/Collapse All Volumes - Only show when volumes exist */}
          {existingVolumes.length > 0 && (
            <div>
              <Tooltip
                text={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.holdingsVolumeManagement.toggleAllVolumes.tooltip"
                    defaultMessage="Expand/Collapse all volumes"
                  />
                }
              >
                {({ ref, ariaIds }) => {
                  const fieldsArray = fields?.value || [];
                  let iconToShow = <FaChevronDown size={14} />;

                  if (fieldsArray.length > 0) {
                    const groupedData = chain(fieldsArray)
                      .sortBy((item) => getVolumeNumber(item.volume))
                      .groupBy((item) => item.volume || 'No_Volume')
                      .value();

                    const volumeKeys = Object.keys(groupedData).map(
                      (vol) => `accordion-volume-${vol}`,
                    );
                    const allExpanded = volumeKeys.every(
                      (key) => volumeAccordionStatus[key],
                    );

                    iconToShow = allExpanded ? (
                      <FaChevronUp size={14} />
                    ) : (
                      <FaChevronDown size={14} />
                    );
                  }

                  return (
                    <Button
                      buttonStyle="default slim"
                      onClick={toggleAllVolumeAccordions}
                      aria-labelledby={ariaIds.text}
                      ref={ref}
                      marginBottom0
                    >
                      {iconToShow}
                    </Button>
                  );
                }}
              </Tooltip>
            </div>
          )}

          {/* Add Volume Button */}
          <div>
            <Tooltip
              id="add-volume-tooltip"
              text={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.holdingsVolumeManagement.addVolume.tooltip"
                  defaultMessage="Add new volume"
                />
              }
            >
              {({ ref, ariaIds }) => (
                <Button
                  onClick={() => setShowAddVolumeModal(true)}
                  onMouseDown={(e) => e.preventDefault()}
                  marginBottom0
                  buttonStyle="primary slim"
                  aria-labelledby={ariaIds.text}
                  ref={ref}
                  disabled={selectedVolumes.length > 0}
                >
                  <FaFolderPlus size={14} />
                </Button>
              )}
            </Tooltip>
          </div>

          {/* Undo History Button */}
          {undoStack.length > 0 && selectedVolumes.length === 0 && (
            <div>
              <Tooltip
                text={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.holdingsVolumeManagement.undoHistory.tooltip"
                    defaultMessage="Show operations history and undo"
                  />
                }
              >
                {({ ref, ariaIds }) => (
                  <Button
                    buttonStyle="default slim"
                    onClick={() => setShowUndoHistory(true)}
                    aria-labelledby={ariaIds.text}
                    ref={ref}
                    marginBottom0
                  >
                    ↶ ({undoStack.length})
                  </Button>
                )}
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    );
  };

  // Volume-specific toolbar renderer - ENHANCED with new buttons
  const renderVolumeToolbar = (volume, volumeItems) => {
    const volumeSelection = volumeSelections[volume] || [];
    const isVolumeSelectAll = volumeSelectAll[volume] || false;

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 16px',
          alignItems: 'center',
          backgroundColor: '#f8f9fa',
          border: '1px solid #e9ecef',
          borderRadius: '6px',
          marginBottom: '16px',
        }}
      >
        {/* Start Actions */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <div>
            <Tooltip
              id={`volume-${volume}-select-all-tooltip`}
              text={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.volumeToolbar.selectAll.tooltip.msg"
                  defaultMessage="Select all items in this volume"
                />
              }
            >
              {({ ref, ariaIds }) => (
                <div aria-labelledby={ariaIds.text} ref={ref}>
                  <Checkbox
                    value={`selectAll-${volume}`}
                    onChange={(e) =>
                      toggleVolumeSelectAll(e, volume, volumeItems)
                    }
                    checked={isVolumeSelectAll}
                    onMouseDown={(e) => e.preventDefault()}
                    disabled={!volumeItems?.length}
                  />
                </div>
              )}
            </Tooltip>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span
              style={{ fontSize: '13px', color: '#495057', fontWeight: '500' }}
            >
              <FormattedMessage
                id="ui-plugin-inventory-templates.volumeToolbar.itemsCount"
                values={{ count: volumeItems.length }}
                defaultMessage="{count} items"
              />
            </span>
            {volumeSelection.length > 0 && (
              <span
                style={{
                  fontSize: '11px',
                  color: '#28a745',
                  backgroundColor: '#d4edda',
                  padding: '2px 6px',
                  borderRadius: '10px',
                  fontWeight: '600',
                }}
              >
                <FormattedMessage
                  id="ui-plugin-inventory-templates.volumeToolbar.selectedCount"
                  values={{ count: volumeSelection.length }}
                  defaultMessage="{count} selected"
                />
              </span>
            )}
          </div>
        </div>

        {/* Middle Actions - Volume Controls */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          {/* Reset Copy Numbers */}
          <Tooltip
            text={
              <FormattedMessage
                id="ui-plugin-inventory-templates.volumeToolbar.resetCopyNumbers.tooltip"
                defaultMessage="Reset copy numbers and standardize volume field"
              />
            }
          >
            {({ ref, ariaIds }) => (
              <Button
                buttonStyle="default slim"
                onClick={() => {
                  setSelectedVolumeForAction(volume);
                  setShowResetVolumeModal(true);
                }}
                aria-labelledby={ariaIds.text}
                ref={ref}
                disabled={!volumeItems?.length || volumeSelection.length > 0}
                marginBottom0
              >
                <FaSync size={14} />
              </Button>
            )}
          </Tooltip>

          {/* Volume Management Actions */}
          <div style={{ display: 'flex', gap: '4px', marginLeft: '8px' }}>
            <Tooltip
              text={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.volumeToolbar.duplicateVolume.tooltip"
                  defaultMessage="Duplicate volume"
                />
              }
            >
              {({ ref, ariaIds }) => (
                <Button
                  buttonStyle="default slim"
                  onClick={() => {
                    setSelectedVolumeForAction(volume);
                    setShowDuplicateVolumeModal(true);
                  }}
                  aria-labelledby={ariaIds.text}
                  ref={ref}
                  disabled={volumeSelection.length > 0}
                  marginBottom0
                >
                  <FaCopy size={12} />
                </Button>
              )}
            </Tooltip>

            <Tooltip
              text={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.volumeToolbar.deleteVolume.tooltip"
                  defaultMessage="Delete entire volume"
                />
              }
            >
              {({ ref, ariaIds }) => (
                <Button
                  buttonStyle="danger slim"
                  onClick={() => {
                    setSelectedVolumeForAction(volume);
                    setShowDeleteVolumeModal(true);
                  }}
                  aria-labelledby={ariaIds.text}
                  ref={ref}
                  disabled={volumeSelection.length > 0}
                  marginBottom0
                >
                  <FaTrash size={12} />
                </Button>
              )}
            </Tooltip>
          </div>
        </div>

        {/* End Actions */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          {volumeSelection.length > 0 && (
            <>
              <div>
                <Tooltip
                  id={`volume-${volume}-delete-tooltip`}
                  text={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.volumeToolbar.deleteSelected.tooltip.msg"
                      defaultMessage="Delete selected items"
                    />
                  }
                >
                  {({ ref, ariaIds }) => (
                    <Button
                      buttonStyle="slim"
                      disabled={!volumeSelection.length}
                      onClick={() => {
                        setSelectedItems(volumeSelection);
                        setOpenDeleteItemsModal(true);
                      }}
                      onMouseDown={(e) => e.preventDefault()}
                      marginBottom0
                      aria-labelledby={ariaIds.text}
                      ref={ref}
                    >
                      <FaTrash size={14} />
                    </Button>
                  )}
                </Tooltip>
              </div>
              <div>
                <Tooltip
                  id={`volume-${volume}-edit-tooltip`}
                  text={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.volumeToolbar.editSelected.tooltip.msg"
                      defaultMessage="Edit selected items"
                    />
                  }
                >
                  {({ ref, ariaIds }) => (
                    <Button
                      buttonStyle="slim"
                      disabled={!volumeSelection.length}
                      onClick={() => {
                        setSelectedItems(volumeSelection);
                        setOpenEditBatchModal(true);
                      }}
                      onMouseDown={(e) => e.preventDefault()}
                      marginBottom0
                      aria-labelledby={ariaIds.text}
                      ref={ref}
                    >
                      <FaEdit size={14} />
                    </Button>
                  )}
                </Tooltip>
              </div>
            </>
          )}
          <div>
            <Tooltip
              id={`volume-${volume}-add-item-tooltip`}
              text={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.volumeToolbar.addItem.tooltip.msg"
                  defaultMessage="Add new item to this volume"
                />
              }
            >
              {({ ref, ariaIds }) => (
                <Button
                  onClick={() => handleAddItemToVolume(volume)}
                  onMouseDown={(e) => e.preventDefault()}
                  marginBottom0
                  buttonStyle="primary slim"
                  aria-labelledby={ariaIds.text}
                  ref={ref}
                  disabled={isVolumeSelectAll || volumeSelection.length > 0}
                >
                  <Icon icon="plus-sign" size="medium" />
                </Button>
              )}
            </Tooltip>
          </div>
        </div>
      </div>
    );
  };

  const renderStartActions = () => {
    if (fields?.value && fields?.value?.length) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <div>
            <Tooltip
              id="holding-items-accordion-header-select-all-tooltip"
              text={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.holdingItemsAccordionHeader.selectAll.tooltip.msg"
                  defaultMessage="Select all"
                />
              }
            >
              {({ ref, ariaIds }) => (
                <div aria-labelledby={ariaIds.text} ref={ref}>
                  <Checkbox
                    value="selectAll"
                    onChange={toggleSelectAll}
                    checked={selectAll}
                    onMouseDown={(e) => e.preventDefault()}
                    disabled={!fields?.value?.length}
                  />
                </div>
              )}
            </Tooltip>
          </div>
          <div>{renderSelectBatch()}</div>
          <div>{renderGoToIndexButton()}</div>
          <div>{renderGoToBarcodeButton()}</div>
          {shouldGroupByVolumes && (
            <div>
              {/* Expand/Collapse All Volumes */}
              <Tooltip
                text={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.holdingItemsAccordionHeader.expandCollapseAllVolumes.tooltip.msg"
                    defaultMessage="Expand/Collapse all volumes"
                  />
                }
              >
                {({ ref, ariaIds }) => {
                  const fieldsArray = fields?.value || [];
                  let iconToShow = <FaChevronDown size={16} />;

                  if (fieldsArray.length > 0) {
                    // Check volume accordion states
                    const groupedData = chain(fieldsArray)
                      .sortBy((item) => getVolumeNumber(item.volume))
                      .groupBy((item) => item.volume || 'No_Volume')
                      .value();

                    const volumeKeys = Object.keys(groupedData).map(
                      (vol) => `accordion-volume-${vol}`,
                    );
                    const allExpanded = volumeKeys.every(
                      (key) => volumeAccordionStatus[key],
                    );

                    iconToShow = allExpanded ? (
                      <FaChevronUp size={16} />
                    ) : (
                      <FaChevronDown size={16} />
                    );
                  }

                  return (
                    <Button
                      buttonStyle="default slim"
                      onClick={onToggleAllAccordions}
                      aria-labelledby={ariaIds.text}
                      ref={ref}
                      marginBottom0
                    >
                      {iconToShow}
                    </Button>
                  );
                }}
              </Tooltip>
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  const renderLastActions = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {selectedItems.length !== 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <Tooltip
                id="holding-items-accordion-header-delete-all-tooltip"
                text={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.holdingItemsAccordionHeader.deleteAll.tooltip.msg"
                    defaultMessage="Delete all"
                  />
                }
              >
                {({ ref, ariaIds }) => (
                  <Button
                    buttonStyle="slim"
                    disabled={!selectedItems.length}
                    onClick={() => {
                      setOpenDeleteItemsModal(true);
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                    marginBottom0
                    aria-labelledby={ariaIds.text}
                    ref={ref}
                  >
                    <FaTrash size={16} />
                  </Button>
                )}
              </Tooltip>
            </div>
            <div>
              <Tooltip
                id="holding-items-accordion-header-delete-all-tooltip"
                text={
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.holdingItemsAccordionHeader.editAll.tooltip.msg"
                    defaultMessage="Edit all"
                  />
                }
              >
                {({ ref, ariaIds }) => (
                  <Button
                    buttonStyle="slim"
                    disabled={!selectedItems.length}
                    onClick={() => setOpenEditBatchModal(true)}
                    onMouseDown={(e) => e.preventDefault()}
                    marginBottom0
                    aria-labelledby={ariaIds.text}
                    ref={ref}
                  >
                    <FaEdit size={18} />
                  </Button>
                )}
              </Tooltip>
            </div>
          </div>
        )}

        {/* Batch create items button for non-volume mode */}
        {!shouldGroupByVolumes && (
          <div style={{ padding: '0 5px' }}>
            <Tooltip
              id="holding-items-accordion-header-create-batch-items-tooltip"
              text={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.holdingItemsAccordionHeader.createBatchItems.tooltip.msg"
                  defaultMessage="Create multiple items"
                />
              }
            >
              {({ ref, ariaIds }) => (
                <Button
                  onClick={() => setShowCreateBatchItemsModal(true)}
                  onMouseDown={(e) => e.preventDefault()}
                  marginBottom0
                  buttonStyle="default"
                  aria-labelledby={ariaIds.text}
                  ref={ref}
                  disabled={selectAll || selectedItems.length}
                >
                  <Icon icon="duplicate" size="medium" />
                </Button>
              )}
            </Tooltip>
          </div>
        )}

        <div style={{ padding: '0 5px' }}>
          <Tooltip
            id="holding-items-accordion-header-delete-all-tooltip"
            text={
              <FormattedMessage
                id="ui-plugin-inventory-templates.holdingItemsAccordionHeader.createNewItem.tooltip.msg"
                defaultMessage="Create new item"
              />
            }
          >
            {({ ref, ariaIds }) => (
              <Button
                onClick={() => setShowCreateSingleItemModal(true)}
                onMouseDown={(e) => e.preventDefault()}
                marginBottom0
                buttonStyle="primary"
                aria-labelledby={ariaIds.text}
                ref={ref}
                disabled={selectAll || selectedItems.length}
              >
                <Icon icon="plus-sign" size="large" />
              </Button>
            )}
          </Tooltip>
        </div>
      </div>
    );
  };

  const renderItemsListToolbar = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: fields?.value?.length ? 'space-between' : 'flex-end',
          padding: '15px 0',
          alignItems: 'center',
          position: 'sticky',
        }}
      >
        {renderStartActions()}
        {renderLastActions()}
      </div>
    );
  };

  const renderEmptyData = () => {
    return (
      <EmptyData
        message={
          <FormattedMessage
            id="ui-plugin-inventory-templates.instanceWizard.itemsList.noFields"
            defaultMessage="No items found."
          />
        }
      />
    );
  };

  const itemContent = useCallback(
    (index) => {
      const isItemHighlighted =
        highlightedIndex !== null && highlightedIndex === index + 1;

      return (
        <div
          style={{
            marginBottom: '4px',
            minHeight: '44px',
          }}
        >
          <RenderItem
            index={index}
            name={`${fields?.name}[${index}]`}
            fields={fields}
            holdingsRecordId={holdingsRecordId}
            template={template}
            controlledVocab={controlledVocab}
            isDisabledItemActions={selectedItems.length}
            isAccordionChecked={
              selectAll ||
              selectedItems.findIndex((s) => Number(s) === index) !== -1
            }
            updateSelection={updateSelection}
            onEditItem={handleEditItem}
            createUndoAction={createUndoAction}
            isHighlighted={isItemHighlighted}
          />
        </div>
      );
    },
    [
      highlightedIndex,
      fields?.name,
      holdingsRecordId,
      template,
      controlledVocab,
      selectedItems,
      selectAll,
      updateSelection,
      handleEditItem,
      createUndoAction,
    ],
  );

  const itemContentInGroup = (index, volume) => {
    const volumeSelection = volumeSelections[volume] || [];
    const isVolumeSelectAll = volumeSelectAll[volume] || false;
    const isItemHighlighted =
      highlightedIndex !== null && highlightedIndex === index + 1;

    return (
      <RenderItem
        index={index}
        name={`${fields?.name}[${index}]`}
        fields={fields}
        holdingsRecordId={holdingsRecordId}
        template={template}
        controlledVocab={controlledVocab}
        isDisabledItemActions={volumeSelection.length}
        isAccordionChecked={
          isVolumeSelectAll ||
          volumeSelection.findIndex((s) => Number(s) === index) !== -1
        }
        updateSelection={(e) => updateVolumeSelection(e, volume)}
        onEditItem={handleEditItem}
        createUndoAction={createUndoAction}
        isHighlighted={isItemHighlighted}
      />
    );
  };

  // Fixed height calculation for optimized performance
  const getVolumeHeight = (volume, volumeItems) => {
    const fixedItemHeight = 48; // Fixed height per item for consistent performance
    const toolbarHeight = 90;
    const padding = 20;

    const totalHeight =
      toolbarHeight + padding + volumeItems.length * fixedItemHeight;

    // Set reasonable limits
    const minHeight = 180;
    const maxHeight = 600; // Reduced for better performance

    return Math.min(Math.max(totalHeight, minHeight), maxHeight);
  };

  // Fixed height optimization - no dynamic recalculation needed

  const renderGroupedItemsList = () => {
    const fieldsArray = fields?.value || [];
    if (!fieldsArray.length) return null;

    const groupedAndSorted = chain(fieldsArray)
      .sortBy((item) => getVolumeNumber(item.volume))
      .groupBy((item) => item.volume || 'No_Volume')
      .value();

    return (
      <div>
        <AccordionSet
          accordionStatus={volumeAccordionStatus}
          onToggle={onToggleAccordion}
        >
          {Object.keys(groupedAndSorted).map((volume) => {
            const volumeNumber = getVolumeNumber(volume);
            const volumeItemsCount = groupedAndSorted[volume].length;
            const volumeHeight = getVolumeHeight(
              volume,
              groupedAndSorted[volume],
            );

            return (
              <div
                key={volume}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '8px',
                  marginBottom: '8px',
                }}
              >
                {/* Volume Checkbox - outside accordion */}
                <div style={{ paddingTop: '8px' }}>
                  <Checkbox
                    checked={selectedVolumes.includes(volume)}
                    onChange={() => toggleVolumeSelection(volume)}
                    value={`volume-${volume}`}
                    onMouseDown={(e) => e.preventDefault()}
                  />
                </div>

                {/* Volume Accordion - without checkbox in label */}
                <div style={{ flex: 1 }}>
                  <Accordion
                    label={
                      <div
                        style={{
                          fontSize: '17px',
                          fontWeight: 'bold',
                          color: '#495057',
                        }}
                      >
                        {volumeNumber !== 'No_Volume' ? (
                          <FormattedMessage
                            id="ui-plugin-inventory-templates.itemsList.volumeAccordion.volume.label"
                            values={{ volume: volumeNumber }}
                            defaultMessage="Volume - {volume}"
                          />
                        ) : (
                          <div style={{ color: '#dc3545' }}>
                            <FormattedMessage
                              id="ui-plugin-inventory-templates.itemsList.volumeAccordion.noVolume.label"
                              defaultMessage="No volume"
                            />
                          </div>
                        )}
                      </div>
                    }
                    displayWhenOpen={
                      <span
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          backgroundColor: '#f8f9fa',
                          padding: '2px 8px',
                          borderRadius: '12px',
                          fontWeight: '500',
                          border: '1px solid #dee2e6',
                          marginLeft: '8px',
                        }}
                      >
                        {volumeItemsCount}
                      </span>
                    }
                    displayWhenClosed={
                      <span
                        style={{
                          fontSize: '12px',
                          color: '#6c757d',
                          backgroundColor: '#f8f9fa',
                          padding: '2px 8px',
                          borderRadius: '12px',
                          fontWeight: '500',
                          border: '1px solid #dee2e6',
                          marginLeft: '8px',
                        }}
                      >
                        {volumeItemsCount}
                      </span>
                    }
                    id={`accordion-volume-${volume}`}
                  >
                    <div style={{ padding: '0 20px' }}>
                      {/* Volume-specific toolbar - disabled when volumes are selected */}
                      {selectedVolumes.length === 0 &&
                        renderVolumeToolbar(volume, groupedAndSorted[volume])}

                      {/* Optimized Virtuoso with fixed height items for better performance */}
                      <Virtuoso
                        key={`virtuoso-volume-${volume}-${highlightedIndex || 'normal'}`}
                        style={{
                          height: `${volumeHeight}px`,
                        }}
                        data={groupedAndSorted[volume]}
                        itemContent={(_, item) => {
                          const itemIndex = fieldsArray.findIndex(
                            (field) => field.id === item.id,
                          );

                          return (
                            <div
                              style={{
                                marginBottom: '4px',
                                minHeight: '44px', // Fixed height for optimal performance
                              }}
                            >
                              {itemContentInGroup(itemIndex, volume)}
                            </div>
                          );
                        }}
                        fixedItemHeight={48} // Enable fixed height optimization
                        increaseViewportBy={100}
                        overscan={2}
                      />
                    </div>
                  </Accordion>
                </div>
              </div>
            );
          })}
        </AccordionSet>
      </div>
    );
  };

  const renderVirtualizedList = () => {
    if (shouldGroupByVolumes) {
      return renderGroupedItemsList();
    }

    const itemCount = fields?.length || 0;

    if (itemCount === 0) {
      return null;
    }

    // Fixed height calculation for regular list - optimized performance
    const calculateRegularListHeight = () => {
      if (isFullScreen) {
        return '90vh';
      }

      const fixedItemHeight = 48; // Fixed height for optimal performance
      const toolbarHeight = 80;
      const padding = 20;
      const minHeight = 250;
      const maxHeight = 600; // Reduced for better performance

      const fieldsArray = fields?.value || [];
      const totalHeight =
        toolbarHeight + padding + fieldsArray.length * fixedItemHeight;

      const optimalHeight = Math.min(
        Math.max(totalHeight, minHeight),
        maxHeight,
      );
      return `${optimalHeight}px`;
    };

    return (
      <div>
        <div
          style={{
            height: calculateRegularListHeight(),
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Virtuoso
            ref={itemsListRef}
            style={{
              height: '100%',
              flex: 1,
            }}
            totalCount={itemCount}
            itemContent={itemContent}
            fixedItemHeight={48} // Enable fixed height optimization
            initialTopMostItemIndex={0}
            increaseViewportBy={100}
            overscan={2}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Holdings-level Volume Management Toolbar - Always visible when grouping is enabled */}
      <div
        style={{
          opacity: isBatchModeActive ? 0.5 : 1,
          pointerEvents: isBatchModeActive ? 'none' : 'auto',
          transition: 'opacity 0.3s ease',
        }}
      >
        {renderHoldingsVolumeManagementToolbar()}
        {!shouldGroupByVolumes && renderItemsListToolbar()}
        {fields?.length !== 0 && renderVirtualizedList()}
        {!fields?.length && renderEmptyData()}
      </div>

      {/* Volume Management Modals */}
      <AddVolumeModal
        open={showAddVolumeModal}
        onClose={() => setShowAddVolumeModal(false)}
        onAdd={handleAddVolume}
        existingVolumes={existingVolumes}
        fields={fields}
        locationId={holdingLocationId}
      />

      <DeleteVolumeModal
        open={showDeleteVolumeModal}
        onClose={() => {
          setShowDeleteVolumeModal(false);
          setSelectedVolumeForAction(null);
        }}
        onDelete={() => handleDeleteVolume(selectedVolumeForAction)}
        volume={selectedVolumeForAction}
        itemCount={
          selectedVolumeForAction
            ? getVolumeItemsCount(fields, selectedVolumeForAction)
            : 0
        }
      />

      <ResetVolumeModal
        open={showResetVolumeModal}
        onClose={() => {
          setShowResetVolumeModal(false);
          setSelectedVolumeForAction(null);
        }}
        onReset={(currentVolume, newVolumeString) => {
          resetVolumeItemNumbers(currentVolume, newVolumeString);
          setSelectedVolumeForAction(null);
        }}
        volume={selectedVolumeForAction}
        volumeItems={
          selectedVolumeForAction
            ? fields.value?.filter(
                (item) =>
                  (item.volume || 'No_Volume') === selectedVolumeForAction,
              ) || []
            : []
        }
      />

      <DuplicateVolumeModal
        open={showDuplicateVolumeModal}
        onClose={() => {
          setShowDuplicateVolumeModal(false);
          setSelectedVolumeForAction(null);
        }}
        onDuplicate={(newVolumeString, barcodeSettings) =>
          handleDuplicateVolume(
            selectedVolumeForAction,
            newVolumeString,
            barcodeSettings,
          )
        }
        sourceVolume={selectedVolumeForAction}
        existingVolumes={existingVolumes}
        fields={fields}
        // Barcode generation props
        existingBarcodes={existingBarcodes}
      />

      <ConfirmDeleteItemsModal
        open={openDeleteItemsModal}
        onClose={() => {
          setOpenDeleteItemsModal(false);
          resetVolumeStates();
        }}
        onRemove={(deletedItems) => {
          // Handle case when deletedItems might be undefined
          if (!deletedItems || !Array.isArray(deletedItems)) {
            console.warn('No items to delete or invalid deletedItems array');
            setSelectedItems([]);
            setSelectAll(false);
            resetVolumeStates();
            return;
          }

          // Ensure fields.value exists before mapping
          const fieldsArray = fields?.value || [];
          if (!fieldsArray.length) {
            console.warn('No items in fields to process');
            setSelectedItems([]);
            setSelectAll(false);
            resetVolumeStates();
            return;
          }

          // Create undo action for deleted items
          const deletedItemsData = deletedItems
            .filter((index) => index < fieldsArray.length) // Only process valid indices
            .map((index) => ({
              item: { ...fieldsArray[index] },
              index,
            }));

          if (deletedItemsData.length === 0) {
            console.warn('No valid items found to delete');
            setSelectedItems([]);
            setSelectAll(false);
            resetVolumeStates();
            return;
          }

          // Extract barcodes from deleted items for session cleanup
          const deletedBarcodes = deletedItemsData
            .map(({ item }) => item.barcode)
            .filter(Boolean); // Filter out empty/null barcodes

          createUndoAction(
            'DELETE_ITEMS',
            {
              deletedItems: deletedItemsData,
              deletedBarcodes, // Store barcodes for undo restoration
            },
            'undoSystem.actions.deleteItems',
          );

          // Remove deleted barcodes from session tracking
          if (deletedBarcodes.length > 0) {
            removeBarcodes(deletedBarcodes);
          }

          setSelectedItems([]);
          setSelectAll(false);
          resetVolumeStates();
        }}
        selectedItems={selectedItems}
        fields={fields}
        holdingsRecordId={holdingsRecordId}
        isFullScreen={isFullScreen}
      />

      <SelectBatchModal
        onClose={() => setIsSelectBatch(false)}
        open={isSelectBatch}
        setSelectedItems={setSelectedItems}
        isFullScreen={isFullScreen}
        goToIndexFunc={goToIndexFunc}
      />

      <EditItemsBatchModal
        open={openEditBatchModal}
        onClose={() => {
          setOpenEditBatchModal(false);
          resetVolumeStates();
        }}
        controlledVocab={controlledVocab}
        template={template}
        fields={fields}
        selectedItems={selectedItems}
        onUpdate={() => {
          setSelectedItems([]);
          setSelectAll(false);
          resetVolumeStates();
        }}
      />

      {/* Batch create items modal for non-volume mode */}
      <CreateItemsBatchModal
        open={showCreateBatchItemsModal}
        onClose={() => setShowCreateBatchItemsModal(false)}
        onCreateItems={handleCreateBatchItems}
        holdingLocationId={holdingLocationId}
        template={template}
        classificationNumber={classificationNumber}
        authorNumber={authorNumber}
        currentItemsCount={fields?.value?.length || 0}
      />

      {/* Single create item modal for both normal and volume modes */}
      <CreateSingleItemModal
        open={showCreateSingleItemModal}
        onClose={() => {
          setShowCreateSingleItemModal(false);
          setSelectedVolumeForModal(null); // Reset selected volume on close
        }}
        onConfirm={handleCreateSingleItem}
        template={template}
        controlledVocab={controlledVocab}
        currentItemsCount={fields?.value?.length || 0}
        holdingLocationId={holdingLocationId}
        classificationNumber={classificationNumber}
        authorNumber={authorNumber}
        selectedVolume={selectedVolumeForModal} // Pass selected volume
        fields={fields} // Pass fields for volume calculations
        instanceStatisticalCodeIds={instanceStatisticalCodeIds}
      />

      {/* Batch Delete Volumes Modal */}
      <BatchDeleteVolumesModal
        open={showBatchDeleteVolumesModal}
        onClose={() => setShowBatchDeleteVolumesModal(false)}
        onConfirm={handleBatchDeleteVolumes}
        selectedVolumes={selectedVolumes}
        volumeItemCounts={volumeItemCounts}
        isDeleting={isBatchDeleting}
      />

      {/* Batch Edit Volumes Modal */}
      <BatchEditVolumesModal
        open={showBatchEditVolumesModal}
        onClose={() => setShowBatchEditVolumesModal(false)}
        onConfirm={handleBatchEditVolumes}
        selectedVolumes={selectedVolumes}
        isProcessing={isBatchEditing}
      />

      {/* Undo notification and history */}
      {renderUndoNotification()}
      {renderUndoHistory()}

      {/* Go To Modal */}
      <GoToModal
        open={goToModalOpen}
        onClose={() => setGoToModalOpen(false)}
        mode={goToMode}
        onGoTo={handleGoToFromModal}
      />
    </>
  );
}

ItemsList.propTypes = {
  fields: PropTypes.object,
  template: PropTypes.object,
  holdingsRecordId: PropTypes.string,
  holdingLocationId: PropTypes.string,
  controlledVocab: PropTypes.object,
  isFullScreen: PropTypes.bool,
  shouldGroupByVolumes: PropTypes.bool,
  onEditItem: PropTypes.func,
  onUndoStackUpdate: PropTypes.func,
  isBatchModeActive: PropTypes.bool,
};

export default ItemsList;
